define.alias("shared/models/tiktok-post", "preview-grid/models/tiktok-post");